import { useEffect, useState } from 'react';
import { FieldDetails } from '@appsvio/jira-rest-api-client';
import client from '@appsvio/jira-rest-api-client/src/forgeFrontendClient';

const MLV_FIELD_TYPE = 'multilevel-cascading-custom-field-type';

const useMultilevelFields = <T>(mapper: (field: FieldDetails) => T) => {
    const [isLoading, setIsLoading] = useState(true);
    const [fields, setFields] = useState<FieldDetails[]>([]);

    useEffect(() => {
        void client
            .getIssueFieldsApi()
            .getFields()
            .then(response => {
                const mlvFieldsOptions = response.filter(field => field.key.startsWith(MLV_FIELD_TYPE));

                setFields(mlvFieldsOptions.sort((a, b) => a.name.localeCompare(b.name)));
            })
            .catch(error => console.error(error))
            .finally(() => setIsLoading(false));
    }, []);

    return [mapper ? fields.map(mapper) : fields, isLoading] as [T[], boolean];
};

export default useMultilevelFields;
